export const rules = {
  required: v => !!v || 'This field is required.',
  url: v => {
    const pattern = /(https?:\/\/.*):?(\d*)\/?(.*)$/;
    return (v && pattern.test(v)) || 'Invalid url.';
  },
};
